import { connect } from 'react-redux';
import 'reselect';
import { searchProductsSelector } from '../../../../redux/search-results/search-results.selectors';
import { searchResultsDispatcher } from '../../../../redux/search-results/search-results.dispatchers';
import SearchResults from './search-results';
export default connect(searchProductsSelector, searchResultsDispatcher)(SearchResults);